import { render, staticRenderFns } from "./BackhaulCustomer.vue?vue&type=template&id=e3529020&scoped=true"
import script from "./BackhaulCustomer.vue?vue&type=script&lang=js"
export * from "./BackhaulCustomer.vue?vue&type=script&lang=js"
import style0 from "./BackhaulCustomer.vue?vue&type=style&index=0&id=e3529020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3529020",
  null
  
)

export default component.exports